<mat-form-field class="filterSelect" [class]="config?.alignment ?? GridCellContentAlignment.Left">
  <mat-select
    multiple="true"
    [placeholder]="context.column.placeholder &&
     (!context.data[context.column.columnDef] || !context.data[context.column.columnDef].length)
     ? context.column.placeholder : ''"
    [(ngModel)]="context.data[context.column.columnDef]"
    [disabled]="!context.cell.allowEditing"
    (selectionChange)="context.cell.actions.onEdited()"
  >
    <mat-option>
      <ngx-mat-select-search
        #matSelectSearch
        [formControl]="filterControl"
        [placeholderLabel]="config?.searchPlaceholderLabel ?? 'Search'"
        [noEntriesFoundLabel]="config?.searchNoEntriesFoundLabel ?? 'No search results'"
        data-testId="select-search"
      >
        <mat-icon color="primary" svgIcon="close" ngxMatSelectSearchClear></mat-icon>
      </ngx-mat-select-search>
    </mat-option>

    <div [class]="colorOptions?.allowColorPicker ? 'optionsWrapper' : ''">
      <mat-option *ngIf="config?.includeNoneOption" [value]="null" data-testId="none-option">
        {{config?.noneOptionName ?? 'None' }}
      </mat-option>
      <mat-option
        *ngFor="let option of filteredOptions$ | async; trackBy: trackByFunction"
        [value]="option.id"
        [attr.data-testId]="option.name"
      >
        {{option.name}}
      </mat-option>
    </div>
  </mat-select>
</mat-form-field>

<ng-content select="selector"></ng-content>
